<script setup lang="ts">
/**
 * The AI Cockpit mark of the design prototype (`icon-coral`, its gradient `ck_grad`): a spark and an
 * arrow, stroked in the AI Cockpit's coral gradient (`--color-ai-cockpit-1` to `-3`, packages/tokens), which
 * stays coral in every brand. Decorative; size it from outside. Each mark has a gradient id of its
 * own, so two on a page do not share one.
 */
import { useId } from "vue";

const gradient = useId();
</script>

<template>
  <svg viewBox="500 4 176 120" fill="none" stroke-width="19" aria-hidden="true" data-ai-cockpit-mark>
    <defs>
      <linearGradient :id="gradient" gradientUnits="userSpaceOnUse" x1="492" y1="88" x2="676" y2="40">
        <stop offset="0" class="[stop-color:var(--color-ai-cockpit-3)]" />
        <stop offset="0.5" class="[stop-color:var(--color-ai-cockpit-2)]" />
        <stop offset="1" class="[stop-color:var(--color-ai-cockpit-1)]" />
      </linearGradient>
    </defs>
    <g :stroke="`url(#${gradient})`">
      <path
        d="M557 106.186C566.769 82.4118 574.91 74.271 599 64.1856C575.226 54.4166 567.085 46.2758 557 22.1855C547.231 45.9593 539.09 54.1001 515 64.1856C538.774 73.9545 546.915 82.0953 557 106.186Z"
      />
      <path d="M608.75 96.1855L659 64.1855L608.75 31.9355" />
    </g>
  </svg>
</template>
